import React from 'react';

class DatePickerInput extends React.Component {
    render() {
        return (
            <div className="wrapper">
                <input
                    onClick={this.props.onClick}
                    className="form-control"
                    value={this.props.value}
                    type="text"
                    readOnly={true}
                />
                <i onClick={this.props.onClick} className="far fa-calendar-alt"></i>
                <i onClick={this.props.onClick} className="fas fa-chevron-down"></i>
            </div>
        );
    }
}

export default DatePickerInput;
